import { render, staticRenderFns } from "./ControleProdutos.vue?vue&type=template&id=90b70a7c&scoped=true&"
import script from "./ControleProdutos.vue?vue&type=script&lang=js&"
export * from "./ControleProdutos.vue?vue&type=script&lang=js&"
import style0 from "./ControleProdutos.vue?vue&type=style&index=0&id=90b70a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b70a7c",
  null
  
)

export default component.exports